"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
exports.concentrationLimitPointerMethods = [
    {
        method: 'enovaInternationalBmoCapitalMarketsCorp1.remainingStateConcentration',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit remainingStateConcentration`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const groupingId = 'application_state';
            (0, common_1.finleyAssert)(lodash_1.default.every(concentrationReceivables, (rec) => lodash_1.default.isString(rec.baseFields[groupingId])), new common_1.error.FinleyError(`baseFields.${groupingId} must be defined to run enovaInternationalBmoCapitalMarketsCorp1.remainingStateConcentration`));
            const groupedStates = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupingId]);
            const sortedStates = lodash_1.default.sortBy(lodash_1.default.values(groupedStates), (receivablesForState) => lodash_1.default.sumBy(receivablesForState, (rec) => {
                (0, common_1.finleyAssert)(lodash_1.default.isNumber(rec.baseFields.outstanding_principal_balance), new common_1.error.FinleyError(`baseFields.outstanding_principal_balance must be defined to run enovaInternationalBmoCapitalMarketsCorp1.remainingStateConcentration`));
                return rec.baseFields.outstanding_principal_balance;
            }));
            // remove last 4
            sortedStates.pop();
            sortedStates.pop();
            sortedStates.pop();
            sortedStates.pop();
            const standardBorrowingBaseReductions = lodash_1.default.map(sortedStates, (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        // eslint-disable-next-line no-param-reassign
                        result[finleyReceivableId] = 0;
                    }
                    // eslint-disable-next-line no-param-reassign
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    {
        method: 'enovaInternationalBmoCapitalMarketsCorp1.remainingIndustryConcentration',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit remainingIndustryConcentration`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const groupingId = 'naics_new_code_c';
            const groupedIndustries = lodash_1.default.groupBy(concentrationReceivables, (rec) => {
                if (!lodash_1.default.isNil(rec.baseFields[groupingId])) {
                    return `${rec.baseFields[groupingId]}`.slice(0, 2);
                }
                return `NULL`;
            });
            if (groupedIndustries.NULL) {
                delete groupedIndustries.NULL;
            }
            const sortedIndustries = lodash_1.default.sortBy(lodash_1.default.values(groupedIndustries), (receivablesForIndustry) => lodash_1.default.sumBy(receivablesForIndustry, (rec) => {
                (0, common_1.finleyAssert)(lodash_1.default.isNumber(rec.baseFields.outstanding_principal_balance), new common_1.error.FinleyError(`baseFields.outstanding_principal_balance must be defined to run enovaInternationalBmoCapitalMarketsCorp1.remainingIndustryConcentration`));
                return rec.baseFields.outstanding_principal_balance;
            }));
            // remove last 2
            sortedIndustries.pop();
            sortedIndustries.pop();
            const standardBorrowingBaseReductions = lodash_1.default.map(sortedIndustries, (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        // eslint-disable-next-line no-param-reassign
                        result[finleyReceivableId] = 0;
                    }
                    // eslint-disable-next-line no-param-reassign
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map